import React from 'react';
import { BsPencil, BsTrash } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectInsured } from '../../../../../../../redux/modules/insured';

function AddressCard({ isDisabled, locationName, toggleAddressForm }) {
  const { country, insuredAddress, insuredCity, insuredState, insuredZip } = useSelector(selectInsured);
  return (
    <Box
      bg="#E6EAEF"
      minW="300px"
      pb={4}
      pl="17px"
      pr="10px"
      py="15px"
    >
      <HStack justifyContent="space-between" mb="8px">
        <Text color="greyScale.800" textStyle="bodyMd500">
          {locationName.toUpperCase()}
        </Text>
        <HStack color="greyScale.900" spacing={2}>
          <Icon
            _hover={{ cursor: [isDisabled ? 'not-allowed' : 'pointer'], color: [!isDisabled && 'primaryScale.600'] }}
            as={BsPencil}
            onClick={() => toggleAddressForm(true)}
          />
          <Icon
            _hover={{ cursor: [isDisabled ? 'not-allowed' : 'pointer'], color: [!isDisabled && 'primaryScale.600'] }}
            as={BsTrash}
            onClick={() => console.log('TODO: dispatch to delete address')}
          />
        </HStack>
      </HStack>
      <Box color={isDisabled && 'greyScale.800'} textStyle="bodyMd" textTransform="capitalize">
        <Text>{insuredAddress}</Text>
        <Text>{`${insuredCity}, ${insuredState}`}</Text>
        <Text>{insuredZip}</Text>
      </Box>
      <Text color="greyScale.800" mt="5px" textStyle="bodyMd">{country === '' && 'United States'}</Text>
    </Box>
  );
}

AddressCard.propTypes = {
  isDisabled: PropTypes.bool,
  locationName: PropTypes.string,
  toggleAddressForm: PropTypes.func
};

AddressCard.defaultProps = {
  locationName: 'Primary Address'
};

export default AddressCard;
